import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToastModule} from 'primeng/toast';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {InputMaskModule} from 'primeng/inputmask';
import {InputTextModule} from 'primeng/inputtext';
import {BlockUIModule} from 'primeng/blockui';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {KeyFilterModule} from 'primeng/keyfilter';
import {MessageModule} from 'primeng/message';
import { ReactiveFormsModule } from '@angular/forms';
import {RadioButtonModule} from 'primeng/radiobutton';
import {CheckboxModule} from 'primeng/checkbox';
import {TabViewModule} from 'primeng/tabview';
import {FileUploadModule} from 'primeng/fileupload';
import {DividerModule} from 'primeng/divider';
import {ProgressBarModule} from 'primeng/progressbar';
import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { TreeTableModule } from "primeng/treetable";
import {SplitButtonModule} from 'primeng/splitbutton';
import {KnobModule} from 'primeng/knob';
import {CardModule} from 'primeng/card';
import { ToggleButtonModule } from 'primeng/togglebutton';

@NgModule({
  declarations: [],
  exports: [
    CommonModule,
    ToastModule,
    ButtonModule,
    DialogModule,
    InputMaskModule,
    InputTextModule,
    BlockUIModule,
    ProgressSpinnerModule,
    KeyFilterModule,
    MessageModule,
    ReactiveFormsModule,
    RadioButtonModule,
    CheckboxModule,
    TabViewModule,
    FileUploadModule,
    DividerModule,
    ProgressBarModule,
    DropdownModule,
    TableModule,
    ConfirmPopupModule,
    ConfirmDialogModule,
    TreeTableModule,
    SplitButtonModule,
    KnobModule,
    CardModule,
    ToggleButtonModule
  ]
})
export class MaterialModule { }
